/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sellers_Stats_OffersInputs */

const id_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran`)
};

const ms_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran`)
};

const da_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const de_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const en_us2_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const es_es2_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos`)
};

const es_mx2_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const fil_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer`)
};

const fr_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres`)
};

const it_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte`)
};

const hu_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok`)
};

const nl_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen`)
};

const no_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const pl_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty`)
};

const pt_br2_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos`)
};

const pt_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const ro_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte`)
};

const fi_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoukset`)
};

const sv_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudanden`)
};

const vi_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi`)
};

const tr_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler`)
};

const cs_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const bg_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферти`)
};

const ru_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложений`)
};

const uk_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозицій`)
};

const ar_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض`)
};

const hi_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र`)
};

const th_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ`)
};

const ja_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー`)
};

const zh_cn2_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项`)
};

const zh_hant1_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目`)
};

const ko_sellers_stats_offers = /** @type {(inputs: Sellers_Stats_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼`)
};

/**
* | output |
* | --- |
* | "Offers" |
*
* @param {Sellers_Stats_OffersInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_stats_offers = /** @type {((inputs?: Sellers_Stats_OffersInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Stats_OffersInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_stats_offers(inputs)
	if (locale === "ms") return ms_sellers_stats_offers(inputs)
	if (locale === "da") return da_sellers_stats_offers(inputs)
	if (locale === "de") return de_sellers_stats_offers(inputs)
	if (locale === "en-US") return en_us2_sellers_stats_offers(inputs)
	if (locale === "es-ES") return es_es2_sellers_stats_offers(inputs)
	if (locale === "es-MX") return es_mx2_sellers_stats_offers(inputs)
	if (locale === "fil") return fil_sellers_stats_offers(inputs)
	if (locale === "fr") return fr_sellers_stats_offers(inputs)
	if (locale === "it") return it_sellers_stats_offers(inputs)
	if (locale === "hu") return hu_sellers_stats_offers(inputs)
	if (locale === "nl") return nl_sellers_stats_offers(inputs)
	if (locale === "no") return no_sellers_stats_offers(inputs)
	if (locale === "pl") return pl_sellers_stats_offers(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_stats_offers(inputs)
	if (locale === "pt") return pt_sellers_stats_offers(inputs)
	if (locale === "ro") return ro_sellers_stats_offers(inputs)
	if (locale === "fi") return fi_sellers_stats_offers(inputs)
	if (locale === "sv") return sv_sellers_stats_offers(inputs)
	if (locale === "vi") return vi_sellers_stats_offers(inputs)
	if (locale === "tr") return tr_sellers_stats_offers(inputs)
	if (locale === "cs") return cs_sellers_stats_offers(inputs)
	if (locale === "bg") return bg_sellers_stats_offers(inputs)
	if (locale === "ru") return ru_sellers_stats_offers(inputs)
	if (locale === "uk") return uk_sellers_stats_offers(inputs)
	if (locale === "ar") return ar_sellers_stats_offers(inputs)
	if (locale === "hi") return hi_sellers_stats_offers(inputs)
	if (locale === "th") return th_sellers_stats_offers(inputs)
	if (locale === "ja") return ja_sellers_stats_offers(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_stats_offers(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_stats_offers(inputs)
	return ko_sellers_stats_offers(inputs)
});
export { sellers_stats_offers as "sellers.stats.offers" }